<template>
  
</template>

<script>
import Slick from 'vue-slick'
    import footermain from "./partials/footer.vue";

export default {
  name: 'hello',
  components: { Slick,
    footermain
   },
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      slickOptions: {
        slidesToShow: 3
      }
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Hello.vue